var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticStyle:{"height":"80px","width":"100%"}},[_c('v-select',{staticClass:"ma-0 pl-4 pr-4 pt-4",attrs:{"items":_vm.internalMarkets,"item-text":"name","label":"Select a location","value":_vm.market.name},on:{"change":_vm.selectionDidChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }